"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.sort");
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
var _user = require("@/api/user");
var _config = require("@/api/config");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserList',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    var validateAdvance = function validateAdvance(rule, value, callback) {
      if (value < 0 || value > 100) {
        callback(new Error('预售金额在0-100之间!'));
      } else {
        callback();
      }
    };
    var validateAmount = function validateAmount(rule, value, callback) {
      if (value <= 0) {
        callback(new Error('结算金额必需大于0!'));
      }
      var dataval = value.split('.');
      if (dataval.length > 1 && dataval[1].length > 2) {
        callback(new Error('结算金额最多保留2位小数!'));
      } else {
        callback();
      }
    };
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        username: undefined,
        mobile: undefined,
        sort: 'add_time',
        order: 'desc',
        email: undefined,
        paidMember: undefined
      },
      downloadLoading: false,
      genderDic: ['未知', '男', '女'],
      statusDic: ['可用', '禁用', '注销'],
      // 我的邀请
      dialogVisiable: false,
      upperList: [],
      subListLoading: false,
      subList: [],
      subTotal: 0,
      subListQuery: {
        userId: undefined,
        page: 1,
        limit: 20,
        sort: 'id',
        order: 'desc'
      },
      // 选择用户
      selectDialogVisiable: false,
      selectLoading: false,
      selectList: [],
      selectTotal: 0,
      selectQuery: {
        page: 1,
        limit: 20,
        sort: 'id',
        order: 'desc',
        username: '',
        mobile: ''
      },
      idKey: 'id',
      multipleSelection: [],
      multipleSelectionAll: [],
      // 用户等级
      dialogFormVisible: false,
      dataForm: {
        id: undefined,
        levelId: undefined
      },
      levelList: [],
      rules: {
        levelId: [{
          required: true,
          message: '用户等级不能为空',
          trigger: 'blur'
        }]
      },
      // 预付金额
      advanceDialogVisible: false,
      advanceForm: {
        id: undefined,
        advanceRatio: undefined
      },
      advanceRules: {
        advanceRatio: [{
          required: true,
          message: '预付金额不能为空',
          trigger: 'blur'
        }, {
          validator: validateAdvance,
          trigger: 'blur'
        }]
      },
      // 分销订单
      orderDialogVisiable: false,
      tab: '1',
      orderLoading: false,
      orderList: [],
      orderTotal: 3,
      orderQuery: {
        page: 1,
        limit: 20,
        sort: 'id',
        order: 'desc',
        type: 1,
        userId: 0
      },
      distributorData: {
        commission: 0,
        distributorOrderCount: 0,
        finishOrderCount: 0,
        orderAmount: 0,
        unsettledAmount: 0,
        withdrawAmount: 0,
        withdrawableAmount: 0
      },
      // 结算
      incomeDialogVisiable: false,
      incomeForm: {
        withdrawableAmount: undefined,
        amount: undefined
      },
      incomeRules: {
        amount: [{
          required: true,
          message: '结算金额不能为空',
          trigger: 'blur'
        }, {
          validator: validateAmount,
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleOrderIm: function handleOrderIm(row) {
      window.open(row.iMUrl);
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _user.fetchList)(this.listQuery).then(function (response) {
        _this.list = response.data.data.list;
        _this.total = response.data.data.total;
        _this.listLoading = false;
      }).catch(function () {
        _this.list = [];
        _this.total = 0;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleDownload: function () {
      var _handleDownload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var parmars, res, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.downloadLoading = true;
              parmars = {
                username: this.listQuery.username,
                mobile: this.listQuery.mobile,
                email: this.listQuery.email,
                paidMember: this.listQuery.paidMember
              };
              _context.n = 1;
              return (0, _user.getUserExport)(parmars);
            case 1:
              res = _context.v;
              this.downloadLoading = false;
              data = res.data;
              console.log(data, 'data');
              if (data.errno == 0) {
                (0, _utils.downloadByUrl)('会员表.xlsx', data.data);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleDownload() {
        return _handleDownload.apply(this, arguments);
      }
      return handleDownload;
    }(),
    // 查看我的邀请
    handleLook: function handleLook(row) {
      // this.subListQuery.userId = row.id
      // this.dialogVisiable = true
      // this.getSubList()
      // this.getUpperList()
      this.$router.push({
        name: 'paylog',
        query: {
          id: row.id
        }
      });
    },
    detail: function detail(row) {
      this.$router.push({
        name: 'userinfo',
        query: {
          id: row.id
        }
      });
    },
    // 获取用户下级列表
    getUpperList: function getUpperList() {
      var _this2 = this;
      (0, _user.listUpper)({
        userId: this.subListQuery.userId
      }).then(function (response) {
        _this2.upperList = response.data.data;
      }).catch(function () {
        _this2.upperList = [];
      });
    },
    // 获取用户下级列表
    getSubList: function getSubList() {
      var _this3 = this;
      this.subListLoading = true;
      (0, _user.listSub)(this.subListQuery).then(function (response) {
        _this3.subList = response.data.data.list;
        _this3.subTotal = response.data.data.total;
        _this3.subListLoading = false;
      }).catch(function () {
        _this3.subList = [];
        _this3.subTotal = 0;
        _this3.subListLoading = false;
      });
    },
    // 移除
    handleRemove: function handleRemove(row) {
      var _this4 = this;
      this.$confirm('是否要移除该用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _user.deleteUserSub)({
          subId: row.userId
        }).then(function (res) {
          _this4.getSubList();
          _this4.$notify.success({
            title: '成功',
            message: '操作成功'
          });
        }).catch(function (response) {
          _this4.$notify.error({
            title: '失败',
            message: response.data.errmsg
          });
        });
      });
    },
    // 添加我邀请的用户
    handleAddUser: function handleAddUser() {
      var that = this;
      that.selectQuery.page = 1;
      that.selectList = [];
      that.selectTotal = 0;
      that.selectDialogVisiable = true;
      this.multipleSelectionAll = [];
      that.getSelectList();
    },
    // 选择用户：查询
    handleFilterSelect: function handleFilterSelect() {
      var that = this;
      // 改变页的时候调用一次
      that.changePageCoreRecordData().then(function (val) {
        that.selectQuery.page = 1;
        that.getSelectList();
      });
    },
    // 选择用户:用户列表页码、页数改变
    handlePaginChange: function handlePaginChange() {
      var that = this;
      // 改变页的时候调用一次
      that.changePageCoreRecordData().then(function (val) {
        that.getSelectList();
      });
    },
    // 选择用户：获取用户列表
    getSelectList: function getSelectList() {
      var _this5 = this;
      this.selectLoading = true;
      (0, _user.fetchList)({
        page: this.selectQuery.page,
        limit: this.selectQuery.limit,
        sort: this.selectQuery.sort,
        order: this.selectQuery.order,
        username: this.selectQuery.username,
        mobile: this.selectQuery.mobile
      }).then(function (response) {
        _this5.selectList = response.data.data.list;
        _this5.selectTotal = response.data.data.total;
        _this5.selectLoading = false;
        setTimeout(function () {
          _this5.setSelectRow();
        }, 200);
      }).catch(function (response) {
        _this5.selectList = [];
        _this5.selectTotal = 0;
        _this5.selectLoading = false;
      });
    },
    // 选择用户：多选改变事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 选择用户：取消选择
    handleCancelSelect: function handleCancelSelect() {
      this.selectDialogVisiable = false;
    },
    // 选择用户：确定选择
    handleSubmitSelect: function handleSubmitSelect() {
      var _this6 = this;
      // 改变页的时候调用一次
      var that = this;
      this.changePageCoreRecordData().then(function (val) {
        // 接口：添加用户
        if (that.multipleSelectionAll.length === 0) {
          _this6.$message.info('请先选择用户');
        } else {
          var subIds = [];
          that.multipleSelectionAll.forEach(function (item, index, array) {
            subIds.push(item.id);
          });
          (0, _user.addUserSub)({
            userId: _this6.subListQuery.userId,
            subIds: subIds
          }).then(function (res) {
            _this6.getSubList();
            _this6.selectDialogVisiable = false;
            if (res.data.data.invalidUserIds.length > 0) {
              var userStr = res.data.data.invalidUserIds.join(',');
              _this6.$notify.error({
                title: '失败',
                message: '用户' + userStr + '已有邀请人，不可再被添加'
              });
            } else {
              _this6.$notify.success({
                title: '成功',
                message: '操作成功'
              });
            }
          }).catch(function (response) {
            _this6.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    setSelectRow: function setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      var idKey = this.idKey;
      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.multipleTable.clearSelection();
      for (var i = 0; i < this.selectList.length; i++) {
        if (selectAllIds.indexOf(this.selectList[i][idKey]) >= 0) {
          this.$refs.multipleTable.toggleRowSelection(this.selectList[i], true);
        }
      }
    },
    changePageCoreRecordData: function changePageCoreRecordData() {
      var _this7 = this;
      return new Promise(function (resolve, reject) {
        var idKey = _this7.idKey;
        if (_this7.multipleSelectionAll.length <= 0) {
          var selectGoodIds = [];
          _this7.multipleSelection.forEach(function (row) {
            selectGoodIds.push({
              id: row[idKey]
            });
          });
          _this7.multipleSelectionAll = selectGoodIds;
          resolve();
          return;
        }
        var selectAllIds = [];
        _this7.multipleSelectionAll.forEach(function (row) {
          selectAllIds.push(row[idKey]);
        });
        var selectIds = [];
        _this7.multipleSelection.forEach(function (row) {
          selectIds.push(row[idKey]);
          if (selectAllIds.indexOf(row[idKey]) < 0) {
            _this7.multipleSelectionAll.push({
              id: row[idKey]
            });
          }
        });
        var noSelectIds = [];
        _this7.selectList.forEach(function (row) {
          if (selectIds.indexOf(row[idKey]) < 0) {
            noSelectIds.push(row[idKey]);
          }
        });
        noSelectIds.forEach(function (id) {
          if (selectAllIds.indexOf(id) >= 0) {
            for (var i = 0; i < _this7.multipleSelectionAll.length; i++) {
              if (_this7.multipleSelectionAll[i][idKey] === id) {
                _this7.multipleSelectionAll.splice(i, 1);
                break;
              }
            }
          }
        });
        resolve();
      });
    },
    // 用户等级
    handleUpdateLevel: function handleUpdateLevel(row) {
      var _this8 = this;
      (0, _config.listLevel)().then(function (response) {
        _this8.levelList = response.data.data.list;
      }).catch(function () {
        _this8.levelList = [];
      });
      this.dataForm = Object.assign({}, row);
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this8.$refs['dataForm'].clearValidate();
      });
    },
    updateData: function updateData() {
      var _this9 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _user.updateUserLevel)({
            userId: _this9.dataForm.id,
            levelId: _this9.dataForm.levelId
          }).then(function () {
            _this9.getList();
            _this9.dialogFormVisible = false;
            _this9.$notify.success({
              title: '成功',
              message: '更新成功'
            });
          }).catch(function (response) {
            _this9.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    // 预付金额
    handleUpdateAdvance: function handleUpdateAdvance(row) {
      var _this0 = this;
      this.advanceForm = Object.assign({}, row);
      this.advanceDialogVisible = true;
      this.$nextTick(function () {
        _this0.$refs['advanceForm'].clearValidate();
      });
    },
    updateAdvance: function updateAdvance() {
      var _this1 = this;
      this.$refs['advanceForm'].validate(function (valid) {
        if (valid) {
          (0, _user.updateUserAdvance)({
            userId: _this1.advanceForm.id,
            advanceRatio: _this1.advanceForm.advanceRatio
          }).then(function () {
            _this1.getList();
            _this1.advanceDialogVisible = false;
            _this1.$notify.success({
              title: '成功',
              message: '更新成功'
            });
          }).catch(function (response) {
            _this1.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    // 设置分销商
    handleSetDistributor: function handleSetDistributor(row) {
      var _this10 = this;
      this.$confirm('是否要设置该用户为分销商?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _user.updateUserDistributor)({
          userId: row.id,
          status: 1
        }).then(function (response) {
          _this10.$notify.success({
            title: '成功',
            message: '操作成功'
          });
          _this10.getList();
        }).catch(function (response) {
          _this10.$notify.error({
            title: '失败',
            message: response.data.errmsg
          });
        });
      });
    },
    // 取消分销商
    handleCancelDistributor: function handleCancelDistributor(row) {
      var _this11 = this;
      this.$confirm('是否要取消该用户的分销商资格?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _user.updateUserDistributor)({
          userId: row.id,
          status: 0
        }).then(function (response) {
          _this11.$notify.success({
            title: '成功',
            message: '操作成功'
          });
          _this11.getList();
        }).catch(function (response) {
          _this11.$notify.error({
            title: '失败',
            message: response.data.errmsg
          });
        });
      });
    },
    // 分销订单
    handleOrder: function handleOrder(row) {
      this.tab = '1';
      this.orderQuery.userId = row.id;
      this.orderQuery.type = 1;
      this.orderQuery.page = 1;
      this.orderDialogVisiable = true;
      this.getOrderList();
      this.distributorInfo();
    },
    // 表格Tab点击事件
    handleClick: function handleClick() {
      this.orderQuery.type = this.tab;
      this.orderQuery.page = 1;
      this.getOrderList();
    },
    // 获取订单列表
    getOrderList: function getOrderList() {
      var _this12 = this;
      this.orderLoading = true;
      (0, _user.distributorOrderList)({
        userId: this.orderQuery.userId,
        type: this.orderQuery.type,
        page: this.orderQuery.page,
        limit: this.orderQuery.limit,
        sort: this.orderQuery.sort,
        order: this.orderQuery.order
      }).then(function (response) {
        _this12.orderList = response.data.data.list;
        _this12.orderTotal = response.data.data.total;
        _this12.orderLoading = false;
      }).catch(function (response) {
        _this12.orderList = [];
        _this12.orderTotal = 0;
        _this12.orderLoading = false;
      });
    },
    // 获取订单列表
    distributorInfo: function distributorInfo() {
      var _this13 = this;
      this.orderLoading = true;
      (0, _user.distributorInfo)({
        userId: this.orderQuery.userId
      }).then(function (response) {
        _this13.distributorData = response.data.data;
      });
    },
    // 结算
    handleIncome: function handleIncome() {
      this.incomeForm = {
        withdrawableAmount: this.distributorData.withdrawableAmount,
        amount: undefined
      };
      this.incomeDialogVisiable = true;
    },
    settleAmount: function settleAmount() {
      var _this14 = this;
      if (this.incomeForm.amount > this.incomeForm.withdrawableAmount) {
        this.$message.error('结算金额不能超过可结算金额');
        return false;
      }
      this.$refs['incomeForm'].validate(function (valid) {
        if (valid) {
          (0, _user.distributorSettle)({
            userId: _this14.orderQuery.userId,
            amount: _this14.incomeForm.amount
          }).then(function (response) {
            _this14.distributorInfo();
            _this14.$notify.success({
              title: '成功',
              message: '操作成功'
            });
          }).catch(function (response) {
            _this14.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    }
  }
};